import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'



export const getDaftarNonBahanBaku = createAsyncThunk('/nonbahan_baku/content', async (nopage) => {
    const userId = localStorage.getItem("userId");
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/daftarnonbahanbaku/${userId}?page=${nopage}`, {})
    
    return response.data;
})

export const daftarnonbahanbakuSlice = createSlice({
    name: 'nonbahan_baku',
    initialState: {
        isLoading: false,
        nonbahan_baku : []
    },

    /*extraReducers: {
        [getDaftarNonBahanBaku.pending]: state => {
			state.isLoading = true
		},
        [getDaftarNonBahanBaku.fulfilled]: (state, action) => {
            state.nonbahan_baku = action.payload.data
			state.isLoading = false
		},
        [getDaftarNonBahanBaku.rejected]: state => {
			state.isLoading = false
		},
    }*/
    extraReducers: (builder) => {
        builder
          .addCase(getDaftarNonBahanBaku.pending, (state) => {
            state.isLoading = true;
          })
          .addCase(getDaftarNonBahanBaku.fulfilled, (state, action) => {
            state.nonbahan_baku = action.payload.data;
            state.isLoading = false;
          })
          .addCase(getDaftarNonBahanBaku.rejected, (state) => {
            state.isLoading = false;
          });
      }
})


export default daftarnonbahanbakuSlice.reducer